<template>
  <b-card class="rounded-xl">
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT CAMPAIGN DETAILS
      </h6>
      <EditDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <AddBannerSidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    />
    <div class="flex  justify-between  items-center">
      <div>
        <h2 class="text-2xl font-semibold">
          Users
        </h2>

        <small class=" text-muted ">Manage your users efficiently here. </small>
      </div>
      <div>
        <base-button type="warning" class="px-8" @click="addBanner">
          Export
        </base-button>
        <base-button type="success" class="px-8" @click="addBanner">
          Import Users
        </base-button>
      </div>
    </div>
    <!-- <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group> -->
    <UsersTable />
  </b-card>
</template>
<script>
import "../../scss/Index.scss";

import EditDetail from "./components/EditDetail.vue";
import AddBannerSidebar from "./components/AddBannerSidebar.vue";
import UsersTable from "./components/UsersTable";

export default {
  components: {
    EditDetail,
    AddBannerSidebar,
    UsersTable,
  },
  data() {
    return {
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },
  },
};
</script>
